import React from 'react';

const PaymentFailed = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-2xl p-8 text-center">
        <div className="mb-6">
          <div className="w-20 h-20 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl text-white">❌</span>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Payment Failed</h1>
          <p className="text-gray-600">Sorry, your payment could not be processed. Please try again.</p>
        </div>

        <div className="space-y-3">
          <button
            onClick={() => window.history.back()}
            className="w-full bg-gradient-to-r from-blue-500 to-purple-600 text-white py-3 rounded-2xl font-semibold"
          >
            🔄 Try Again
          </button>
          <button
            onClick={() => window.location.href = '/'}
            className="w-full bg-gray-500 text-white py-3 rounded-2xl font-semibold"
          >
            🏠 Go Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;